import React from 'react'
import { Typography, Paper, Accordion, AccordionSummary, AccordionDetails, Chip, Box } from '@mui/material'
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { useTranslations } from '@/lib/next-shim'
import dayjs from 'dayjs'
import { FormSubmission, FormSubmissionStatus, GetMyInfosQuery } from '@/core/graphql/types'
import FormSubmissionDetails from './FormSubmissionDetails'

interface FormSubmissionsListProps {
  submissions: GetMyInfosQuery['myInfos']['formSubmissions']
  contextType: 'consultation' | 'expertise' | 'order'
  contextId: string
}

export const FormSubmissionsList: React.FC<FormSubmissionsListProps> = ({ submissions, contextType, contextId }) => {
  const t = useTranslations()

  if (!submissions.length) {
    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" color="textSecondary">
          {t('base.noData')}
        </Typography>
      </Box>
    )
  }

  return (
    <Paper sx={{ mt: 2 }}>
      {submissions.map((submission) => (
        <Accordion key={submission._id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`submission-${submission._id}-content`} id={`submission-${submission._id}-header`}>
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <Typography variant="subtitle1">{submission.template.title}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, gap: 2 }}>
                <Typography variant="body2" color="textSecondary">
                  {submission.status === FormSubmissionStatus.Submitted ? (
                    <>
                      {t('page.forms.submission.submittedAt')}: {dayjs(submission.submittedAt).format('YYYY-MM-DD HH:mm')}
                    </>
                  ) : (
                    <>
                      {t('page.forms.submission.lastModified')}: {dayjs(submission.updatedAt).format('YYYY-MM-DD HH:mm')}
                    </>
                  )}
                </Typography>
                <Chip
                  size="small"
                  label={t(`page.forms.submission.status.${submission.status}`)}
                  color={submission.status === FormSubmissionStatus.Draft ? 'warning' : 'success'}
                />
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <FormSubmissionDetails submission={submission} />
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  )
}
